<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการผู้ดูแลระบบ (Admin)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-user"></i> จัดการผู้ดูแลระบบ (Admin)
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="form"
                    class="demo-ruleForm"
                  >
                    <div class="col-sm-6">
                      <el-form-item label="คำค้นหา" prop="text">
                        <el-input clearable v-model="form.text" placeholder="กรุณากรอกคำค้นหา เช่น ชื่อ นามสกุล หรืออีเมล"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="เบอร์โทรศัพท์" prop="phone">
                        <el-input
                          maxlength="10"
                          show-word-limit
                          v-model="form.phone"
                          @keypress.native="isNumberKey"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="สถานะ">
                        <el-checkbox-group v-model="form.status">
                          <el-checkbox label="Active"></el-checkbox>
                          <el-checkbox label="Inactive"></el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div class="col-sm-12">
                      <div class="layout_filter_btn">
                        <button type="button" @click="search()" class="btn btn-primary">ค้นหา</button>
                      </div>
                    </div>
                  </el-form>
                </div>
                <div v-if="user_permission.add" class="pull-right box_add">
                  <button class="btn btn-info btn_custom" @click="change_view">
                    <i class="fa fa-plus">เพิ่มผู้ดูแล</i>
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                    @query-change="search"
                    :data="data_table"
                    :total="total"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column prop="namePic" label="รูปภาพ" width="130">
                      <template slot-scope="scope">
                       <div class="img-radius">
                          <img :src="config().API_URL+scope.row.profile_img" alt /> 
                        </div> 
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="fullname" label="ชื่อ - นามสกุล" width="260" ></el-table-column>
                    <el-table-column sortable prop="email" label="อีเมล" width="260"></el-table-column>
                    <el-table-column sortable prop="phone_number" label="เบอร์โทรศัพท์" width="150"></el-table-column>
                    <el-table-column sortable prop="username" label="ชื่อผู้ใช้งาน" width="210"></el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่ลงทะเบียนเริ่มใช้งาน" width="118"></el-table-column>
                    <el-table-column sortable="custom" prop="latest_login" label="วันและเวลาที่เข้าใช้งานล่าสุด" width="100"></el-table-column>
                    <el-table-column sortable="custom" prop="status" label="สถานะ"></el-table-column>
                    <el-table-column label="จัดการ" align="center" width="200" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                        <el-button
                          class="custom-btn"
                          size="mini"
                          type="success"
                          @click="handleView(scope.row)"
                        >
                          <i class="el-icon-view"></i>
                        </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                        <el-button
                          :disabled="scope.row.status == 'Inactive'"
                          v-if="user_permission.edit"
                          class="custom-btn"
                          size="mini"
                          type="primary"
                          @click="handleEdit(scope.row)"
                        >
                          <i class="el-icon-edit"></i>
                        </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                        <el-button
                          :disabled="scope.row.status == 'Inactive'"
                          v-if="user_permission.delete"
                          class="custom-btn"
                          size="mini"
                          type="danger"
                          @click="handleDelete(scope.row)"
                        >
                          <i class="el-icon-delete-solid"></i>
                        </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <InfoAdmin :data="information" :dialog="dialog" @checkModal="closeModal"></InfoAdmin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import InfoAdmin from "../Modal/Modal_viewInfoAdmin";
export default {
  components: {
    InfoAdmin: InfoAdmin
  },
  data() {
    return {
      user_permission : {
        add :false,
        edit : false,
        delete : false
      },
      information: { first_name: "" },
      dialog: false,
      label_position: "top",
      data_dialog: null,
      dialogVisible: false,
      tableProps: {
        border: true
      },
      form: { 
        text: "", 
        phone: "", 
        status: ["Active"],
        page: 1, 
        pageSize: 10,
        sort: {
          order: null,
          prop: null
        }
      },
    };
  },
  mounted(){
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_admin; 
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
    ...mapState({
      profileImg:store => store.Menu.profileImg,
      data_table: store => store.Manage_admin.data_table,
      total: store => store.Manage_admin.total,
      loading: store => store.Manage_admin.loading
    })
  },
  methods: {
    ...mapActions({
      search_admin: "Manage_admin/search_admin",
      deleteAdmin: "Manage_admin/deleteAdmin"
    }),
    handleClose(done) {
      done();
    },
    handleView(data) {
      this.information = data;
      this.dialog = true;
    },
    handleEdit(row_data) {
      this.$store.commit('Manage_admin/SET_EDIT_DATA',row_data)
      this.$router.push({ name: "Edit_admin"});
    },
    handleDelete(info) {
      this.$confirm("ลบผู้ดูแลระบบ", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.deleteAdmin(info.admin_id);
      })
      .catch(() => {});
    },
    change_view() {
      this.$router.push({ name: "Add_admin" });
    },
    search(queryInfo) {
      let formdata = Object.assign(this.form, queryInfo)
      this.search_admin(formdata)
    },
    closeModal(value) {
      this.dialog = value;
    }
  }
};
</script>
